export default "__VITE_ASSET__13aef84f__"